import React, { useState } from "react";
import { useLpStore } from "../../../store/useLiquidityPartner";
import { MdOutlineCheck } from "react-icons/md";
import _ from "lodash";

const StableWalletCard = ({ key, lp }: { key: any; lp: any }) => {
  const Lp = useLpStore((state) => state.Lp);
  
  const [cardState, setCardState] = useState<boolean>(false);
  const setShowWalletModal = useLpStore((state) => state.setShowWalletModal);
  const setWallet = useLpStore((state) => state.setWallet);
  const activeLp = useLpStore((state) => state.activeLp);
  const showWalletModal = useLpStore((state) => state.showWalletModal);

  const handleState = () => {
    setShowWalletModal(true);
    // setCardState((cardState) => !cardState);
  };
  console.log(showWalletModal, "active");

  const activeCard = activeLp
    ? "border-2 border-[#0eb683] shadow-md relative"
    : " h-20 border rounded-lg flex items-center justify-between px-5 relative cursor-pointer shadow-sm ";

  return (
    <div
      key={key}
      onClick={() => {
        setShowWalletModal(true);
        setWallet(lp);
      }}
      className={` ${activeCard} ${
        activeLp ? "bg-gradient-to-r from-[#fff] to-[#e3f8f1]" : null
      }  h-20 border rounded-lg flex items-center justify-between px-4 relative cursor-pointer bg-clip-border  active:scale-100 shadow-sm`}
    >
      <div>
        <h1 className="text-lg font-light text-[#030303] mt-1">{Lp.name}</h1>
        <h1 className=" font-light text-[#0eb683]  text-sm">{lp.walletType}</h1>
        <div className="flex items-center">
          <span className="text-[#696677] text-xs">
            {_.capitalize(lp.blockchain)}
          </span>{" "}
          -{" "}
          <span className=" text-[#696677] text-xs">
            {lp.walletAddress.substring(0, 20) + "..."}
          </span>
        </div>
      </div>
      {activeLp ? (
        <div className="rounded-full w-5 h-5 bg-[#0eb683] flex items-center justify-center absolute top-6 right-6 ">
          <MdOutlineCheck size={24} fill="#fff" />{" "}
        </div>
      ) : null}
      {activeLp ? (
        <div className="absolute h-1 w-1 rounded-full bg-[#00D266]  top-1 right-1 shadow-lg animate-ping"></div>
      ) : (
        <div className="absolute h-[6px] w-[5px] rounded-full bg-slate-400  top-1 right-1 "></div>
      )}
    </div>
  );
};

export default StableWalletCard;
